/**
 * Disable Ant Design Wave Effect
 * This script disables the wave/ripple effect at the JavaScript level
 * Must be imported before any Ant Design components
 */

// Override the wave effect at the global level
if (typeof window !== 'undefined') {
  // Store original requestAnimationFrame
  const originalRAF = window.requestAnimationFrame;
  
  // Override requestAnimationFrame to block wave animations
  window.requestAnimationFrame = function(callback: FrameRequestCallback): number {
    // Check if this is a wave animation by inspecting the call stack
    const stack = new Error().stack || '';
    
    // Block if it's related to Ant Design wave effect
    if (stack.includes('showWaveEffect') || 
        stack.includes('ant-wave') || 
        stack.includes('waveEffect')) {
      // Return a dummy ID and don't execute the callback
      return -1;
    }
    
    // Otherwise, use the original requestAnimationFrame
    return originalRAF.call(window, callback);
  };

  // Also disable the wave effect by modifying the prototype
  // This prevents Ant Design from creating wave elements
  const originalCreateElement = document.createElement.bind(document);
  document.createElement = function(tagName: string, options?: ElementCreationOptions): any {
    const element = originalCreateElement(tagName, options);
    
    // If it's trying to create a wave element, return a dummy element
    if (element.className && typeof element.className === 'string' && 
        element.className.includes('ant-wave')) {
      // Return an element that does nothing
      const dummy = originalCreateElement('div');
      dummy.style.display = 'none';
      dummy.style.opacity = '0';
      dummy.style.pointerEvents = 'none';
      return dummy;
    }
    
    return element;
  };
}

export {};
